import * as React from "react"
import { CustomLink } from "@/components"
import * as styles from "./index.module.scss"

interface IProps {
  cardInfo: AboutUsMediaReports
}

const MediaReportsCard: React.FC<IProps> = ({ cardInfo }) => {
  return (
    <CustomLink
      linkTo={cardInfo.link}
      className={`common-card-content ${styles.mediaReportsCard}`}
    >
      <p className={styles.date}>{cardInfo.date}</p>
      <div className={styles.inner}>
        <p>{cardInfo.title}</p>
        <div className={styles.logo}>
          <img alt={cardInfo.logo.alt} src={cardInfo.logo.media.url} />
        </div>
      </div>
    </CustomLink>
  )
}

export default MediaReportsCard
